import { render } from "./otherTable.vue?vue&type=template&id=b4b4bf80&scoped=true"
import script from "./otherTable.vue?vue&type=script&lang=js"
export * from "./otherTable.vue?vue&type=script&lang=js"

import "./otherTable.vue?vue&type=style&index=0&id=b4b4bf80&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b4bf80"]])

export default __exports__